<template>
  <div class="getCouponCenterDetail">
    <div class="base-info">
      <el-row class="row-info">
        <el-col :span="2" class="col-label">活动名称</el-col>
        <el-col :span="22" class="col-value">{{ form.name }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">活动时间</el-col>
        <el-col :span="22" class="col-value">
          {{ form.startTime ? $moment(form.startTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
          {{ form.endTime ? ' - ' + $moment(form.endTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">入口场景</el-col>
        <el-col :span="22" class="col-value">{{ form.entryScene_data ? form.entryScene_data.desc : '---' }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">券渠道</el-col>
        <el-col :span="22" class="col-value">{{ channelTypeObj[form.channel] }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">券类型</el-col>
        <el-col :span="22" class="col-value">{{ couponTypeObj[form.couponKind] }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">{{ couponTypeObj[form.couponKind] }}</el-col>
        <el-col :span="22" class="col-value">
          <div class="coupon-table" style="margin-left: 0;">
            <coupon-table :tableTrData="tableTrData" :couponType="form.couponKind"></coupon-table>
          </div>
        </el-col>
      </el-row>
      <el-row class="row-info" v-if="form.channel=='VoucherCenter'&&form.appendRecord.length!=0">
        <el-col :span="2" class="col-label">追加记录</el-col>
        <el-col :span="22" class="col-value">
          <div class="coupon-table" style="margin-left: 0;">
            <Table
              :tableThData="voucherCenter_tableThData"
              :tableTrData="form.appendRecord"
              :pagination="false"
            >
           <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---'}}</template>
           <template #sort="{ row }">{{ row.sort }}</template>
           <template #amount="{ row }">{{ row.amount }}</template>
            </Table>
          </div>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">发放数量</el-col>
        <el-col :span="22" class="col-value">{{ form.amount }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">是否隐藏券</el-col>
        <el-col :span="22" class="col-value">{{ form.hidden ? '是' : '否' }}</el-col>
      </el-row>
      <template v-if="form.entryScene == 'CouponCenter'">
        <el-row class="row-info" v-if="!form.hidden">
          <el-col :span="2" class="col-label">是否同步首页</el-col>
          <el-col :span="22" class="col-value">{{ form.deliveryChannel?'是':'否' }}</el-col>
        </el-row>
        <el-row class="row-info" v-if="!form.hidden && form.deliveryChannel">
          <el-col :span="2" class="col-label">渠道序号</el-col>
          <el-col :span="22" class="col-value">{{ form.sort}}</el-col>
        </el-row>
      </template>
      <el-row class="row-info" v-if="!form.hidden">
        <el-col :span="2" class="col-label">活动序号</el-col>
        <el-col :span="22" class="col-value">{{ form.sorted || '未配置'}}</el-col>
      </el-row>
      <template v-if="showShareConfig && form.channel == 'VoucherCenter' && form.couponKind == 'CouponCenter'">
        <el-row class="row-info">
          <el-col :span="2" class="col-label">领取方式</el-col>
          <el-col :span="22" class="col-value">{{ shareTypeObj[form.shareType]}}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">用户分销佣金</el-col>
          <el-col :span="22" class="col-value">{{ form.commission || '未配置'}}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">二级分销佣金</el-col>
          <el-col :span="22" class="col-value">{{ form.secondaryCommission || '未配置'}}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">邀请人佣金</el-col>
          <el-col :span="22" class="col-value">{{ form.inviterCommission || '未配置'}}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">分享appId</el-col>
          <el-col :span="22" class="col-value">{{ form.issueAppId || '未配置'}}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">分享小程序链接</el-col>
          <el-col :span="22" class="col-value">{{ form.issueUrl || '未配置'}}</el-col>
        </el-row>
      </template>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">券每天总发限制</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.dailyTotal === '1'">无限制</span>
          <span v-else>每天总限发{{ form.dailyTotalLimit }}张</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">每日限领次数</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.userDaily === '1'">无限制</span>
          <span v-else>每人每天限领{{ form.userDailyLimit }}张</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">用户总领限制</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.userTotal === '1'">无限制</span>
          <span v-else>每人总限领{{ form.userTotalLimit }}张</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">发放用户</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.useRange == 'AllUser'">所有用户</span>
          <span v-if="form.useRange == 'SpecifyUser'">指定画像</span>
        </el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">范围类型</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="form.scopeType == 'AllMall'">所有商场</span>
          <div v-if="form.scopeType == 'Mall'">
            <span v-for="item in filterMallData" :key="item.id">{{ item.name }}，</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import couponTable from '../../components/couponTable.vue'
import Table from "@/components/Table/index";
export default {
  name: "getCouponCenterDetail",
  components: {
    couponTable,
    Table
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tableTrData: {
      type: Array,
      default: () => []
    },
    filterMallData: {
      type: Array,
      default: () => []
    },
    showShareConfig: Boolean
  },
  data() {
    return {
      couponTypeObj: {
        'Coupon': '优惠券',
        'CouponCenter': '优惠券',//券中台优惠券
        'GiftCoupon': '礼品券',
        'LotCoupon': '停车券',
        'DeductCoupon': '抵扣券'
      },
      shareTypeObj: {
        "Issue": "仅领取券",
        "Share": "仅分享券",
        "IssueAndShare": "领取加分享",
      },
      channelTypeObj: {
        'RT': '闰土自制',
        'VoucherCenter': '券中台投放',
      },
      voucherCenter_tableThData:[
        { prop: "updated", label: "追加时间", minWidth: "200", },
        { prop: "sort", label: "追加次数", minWidth: "90", },
        { prop: "amount", label: "追加数量", minWidth: "120", },
      ],//券中台追加记录列表
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.getCouponCenterDetail {
  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }
   .coupon-table {
    width: 80%;
    margin-left: 130px;
    margin-bottom: 20px;
  }
  .table-box {
    margin-top: 0;
  }
}
</style>
